import checkPendingAttachmentOperation from '../actions/checkPendingAttachmentOperation';
import checkPendingAttachmentOperationService from '../services/checkPendingAttachmentOperation';
import CheckPendingAttachmentOperationResponse from 'owa-service/lib/contract/CheckPendingAttachmentOperationResponse';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';

export {
    default as AttachmentOperationType,
} from 'owa-service/lib/contract/AttachmentOperationType';
export { CheckPendingAttachmentOperationResponse, ClientAttachmentId, ClientItemId };

export default orchestrator(checkPendingAttachmentOperation, async actionMessage => {
    try {
        const mailboxInfo = actionMessage.itemId
            ? actionMessage.itemId.mailboxInfo
            : actionMessage.attachmentId.mailboxInfo;

        const response = await checkPendingAttachmentOperationService(
            actionMessage.attachmentId ? actionMessage.attachmentId.Id : null,
            actionMessage.itemId ? actionMessage.itemId.Id : null,
            actionMessage.operationId,
            actionMessage.operationType,
            mailboxInfo.requestOptions
        );

        actionMessage.completeHandler(response);
    } catch (e) {
        // We will swallow any errors here. This is an auxiliary action and if it fails, we will log a warning but we
        // don't want any real users to be affected.
        trace.warn('checkPendingAttachmentOperationAction is failing with error: ' + e);
    }
});
